import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {}

export const getters = {}

export const mutations = {
  CACHE_GROUPS(state, groups) {
    state.cached = groups
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchRetinaGroups(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/retina-groups/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_GROUPS', request)
      return request
    })
  },

  fetchRetinaGroupsDetail(context, query) {
    return axios.get(`${serverUrl}/APIv1/retina-groups/${query}`).then((response) => {
      return response.data
    })
  },

  createUpdateRetinaGroups(context, formData) {
    let promise = null
    if (formData.action == 'update'){
      promise =  axios.put(`${serverUrl}/APIv1/retina-groups/${formData.id}/`, formData)
    }else {
      promise =  axios.post(`${serverUrl}/APIv1/retina-groups/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  deleteRetinaGroups(context, id) {
    let promise = null
    promise =  axios.delete(`${serverUrl}/APIv1/retina-groups/${id}/`)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }

}